import {
  LAYOUT_MINIMAL,
  LAYOUT_RECTANGLE,
  LAYOUT_SQUARE,
} from '@bnnvara/cards/src/components/GridCard/GridCard';

export function getLayout(index, total) {
  switch (index) {
    case 0:
      return {
        mobile: LAYOUT_SQUARE,
        tablet: total === 2 ? LAYOUT_SQUARE : LAYOUT_RECTANGLE,
        desktop:
          total === 4 || total === 5 || total === 8
            ? LAYOUT_SQUARE
            : LAYOUT_RECTANGLE,
      };
    case 1:
      return {
        mobile: LAYOUT_MINIMAL,
        tablet: total > 3 ? LAYOUT_MINIMAL : LAYOUT_SQUARE,
        desktop:
          total === 2 || total === 4 || total === 6
            ? LAYOUT_RECTANGLE
            : LAYOUT_SQUARE,
      };
    case 2:
      return {
        mobile: LAYOUT_MINIMAL,
        tablet: total === 3 ? LAYOUT_SQUARE : LAYOUT_MINIMAL,
        desktop: LAYOUT_SQUARE,
      };
    default:
      return {
        mobile: LAYOUT_MINIMAL,
        tablet: LAYOUT_MINIMAL,
        desktop: LAYOUT_SQUARE,
      };
  }
}

export function getColumnMd(layout, total) {
  if (total === 2) {
    return 'span 6';
  }

  if (total === 3 && layout === LAYOUT_SQUARE) {
    return 'span 6';
  }

  return 'span 12';
}

export function getColumnLg(layout, index, total) {
  if (index === 0 && (total === 4 || total === 5)) {
    return 'span 6';
  }

  if (layout === LAYOUT_RECTANGLE) {
    return 'span 6';
  }

  return 'span 3';
}

export function getRowLg(index, total) {
  if (index === 0 && (total === 4 || total === 5)) {
    return 'span 2';
  }

  return 'span 1';
}
